import { ServiceApplication_Key } from "../../../../config/helpers";
import { IFilterInscription } from "../../../../models/interfaces/IFilterInscription";
import { IInscriptionResult, IInscriptionDetailResult, IInscriptionUpdateReponse, IInscriptionUpdate } from "../../../../models/interfaces/IInscription";

import { apiSlice } from "../../api";

export interface demandeInscriptionApiQueryBody {
    Application_Key: string;
    // eslint-disable-next-line
    Values: any;
}

export const demandeInscriptionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchBODemandesInscriptions: builder.query<IInscriptionResult, IFilterInscription | undefined>({
      query: (obj) => {
        const body: demandeInscriptionApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };
        return {
          url: "/BO/DemandeInscription/Demande_Inscription_Search",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchBODemandeInscription: builder.query<IInscriptionDetailResult, number>({
      query: (id: number) => {
        const body: demandeInscriptionApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {
            IdDemandeInscription: id,
          },
        };
        return {
          url: "/BO/DemandeInscription/Demande_Inscription_Get",
          method: "POST",
          body: body,
        };
      },
    }),
    updateReponseDemandeInscription: builder.mutation<IInscriptionDetailResult, IInscriptionUpdateReponse>({
      query: (data) => {
        const body: demandeInscriptionApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/DemandeInscription/Demande_Inscription_Update_Reponse",
          method: "POST",
          body: body,
        };
      },
    }),
    priseEnChargeDemandeInscription: builder.mutation<IInscriptionDetailResult, { Id: number; IdEtatDemandeInscription: number }>({
      query: (data) => {
        const body: demandeInscriptionApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/DemandeInscription/Demande_Inscription_PriseEnCharge",
          method: "POST",
          body: body,
        };
      },
    }),
    updateDemandeInscription: builder.mutation<IInscriptionDetailResult, IInscriptionUpdate>({
      query: (data) => {
        const body: demandeInscriptionApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/DemandeInscription/Demande_Inscription_Update",
          method: "POST",
          body: body,
        };
      },
    }),
  }),
});

export const {
  useFetchBODemandesInscriptionsQuery,
  useLazyFetchBODemandesInscriptionsQuery,
  useFetchBODemandeInscriptionQuery,
  useLazyFetchBODemandeInscriptionQuery,
  useUpdateReponseDemandeInscriptionMutation,
  usePriseEnChargeDemandeInscriptionMutation,
  useUpdateDemandeInscriptionMutation
} = demandeInscriptionApi;
